// PasswordConfirm

const rule = {
	name: 'passwordConfirm',
	method: (value, element, params) => value == element.closest('form').querySelector('input.password').value,
	errorMessage: (params, element) => 'Passwords do not match'
};

export default rule;
